export const themeElements = {
   dark: {
      backgroundColor: "hsl(209, 23%, 22%)",
      color: "white",
   },
   light: {
      backgroundColor: "hsl(0, 0%, 98%)",
      color: "hsl(200, 15%, 8%)",
   },
};